var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvertedSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.1,
    fill: "none",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 80,
    height: 80.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.5,
    fill: "none",
    width: 70,
    height: 69.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 10,
    y: 10,
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 10.9,
    fill: "#D2D2D2",
    width: 67.2,
    height: 59.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 6.2,
    y: 2.4,
    width: 67.2,
    height: 67.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#717070",
    d: "M40.6,83.6h-0.2v-72c0.1,0,0.1,0,0.2,0V11c-0.5,0.1-0.9,0-1,0c-0.5-0.1-3-0.4-7.7-0.4 c-4.9,0-7.5,0.4-7.9,0.5c-0.5-0.1-3.4-0.5-7.2-0.5c-1.8,0-3.3,0.2-4.4,0.3c-1.5,0.2-2.6,0.3-3.7,0c-1.4-0.4-2.8-0.2-3.6,0V-2.5 h35.5v-0.9H4.2v87.9h36.4V83.6z M8.4,83.6H5.1V11.7c0.6-0.2,1.9-0.5,3.3-0.1V83.6z M23.6,83.6H9.3V11.8c1,0.1,2,0,3.2-0.1 c0.9-0.1,1.9-0.2,3-0.3h3c2.5,0.1,4.4,0.3,5.1,0.4V83.6z M39.5,83.6H24.5V11.8c0.8-0.1,2.5-0.3,5.3-0.4H34 c3.8,0.1,5.6,0.4,5.6,0.4l0,0V83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717070",
    d: "M40.2-3.4v0.9h34.3v13.3c-1.6-0.5-3.4,0.1-3.9,0.2c-0.5-0.1-3-0.4-7.7-0.4c-4.9,0-7.5,0.4-7.9,0.5 c-0.5-0.1-3.4-0.5-7.2-0.5c-1.8,0-3.3,0.2-4.4,0.3c-1.3,0.1-2.2,0.2-3.2,0.1v73.6h35.2V-3.4H40.2z M54.5,83.6H40.2V11.8 c1,0.1,2,0,3.2-0.1c0.9-0.1,1.9-0.2,3-0.3h3c2.5,0.1,4.4,0.3,5.1,0.4V83.6z M70.5,83.6H55.4V11.8c0.8-0.1,2.5-0.3,5.3-0.4h4.2 c3.8,0.1,5.6,0.4,5.6,0.4l0,0V83.6z M74.4,83.6h-3.1v-72c0.8-0.2,2.1-0.4,3.1,0V83.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#9D9D9C",
    stroke: "#717070",
    strokeWidth: 0.6424,
    strokeMiterlimit: 10,
    points: "24.1,21.3 22.3,74.1 26.2,74.1  24.1,20.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#9D9D9C",
    stroke: "#717070",
    strokeWidth: 0.6424,
    strokeMiterlimit: 10,
    points: "40,19.4 38.1,74.1 42.1,74.3  40,18.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#9D9D9C",
    stroke: "#717070",
    strokeWidth: 0.6424,
    strokeMiterlimit: 10,
    points: "55,19.3 53.1,74.1 57.1,74.1  55,18.8  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedSketch);
export default __webpack_public_path__ + "static/media/Inverted_sketch.8beb68e7914d72c4280a1493dcf1a0ba.svg";
export { ForwardRef as ReactComponent };